import config from "@/config";
import http from "@/utils/request";

export default {
	userMerchantInfo: {
		list: {
			url: `${config.API_URL}/admin/user/getUserMerchantInfoList`,
			name: "用户商户信息列表",
			get: async function (data = {}, config = {}) {
				return await http.get(this.url, data, config);
			},
		},
	},
	template: {
		list: {
			url: `${config.API_URL}/api/ly/contract/templateList`,
			name: "合同模板列表",
			get: async function (data = {}, config = {}) {
				return await http.get(this.url, data, config);
			},
		},
		page: {
			url: `${config.API_URL}/api/ly/contract/templatePage`,
			name: "合同模板列表",
			get: async function (data = {}, config = {}) {
				return await http.get(this.url, data, config);
			},
		},
		add: {
			url: `${config.API_URL}/api/ly/contract/addTemplate`,
			name: "新增合同模板",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		edit: {
			url: `${config.API_URL}/api/ly/contract/editTemplate`,
			name: "编辑合同模板",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
	},
	subjectInfo: {
		list: {
			url: `${config.API_URL}/api/ly/contract/SubjectInfo/page`,
			name: "合同主体信息分页",
			get: async function (data = {}, config = {}) {
				return await http.get(this.url, data, config);
			},
		},
		add: {
			url: `${config.API_URL}/api/ly/contract/SubjectInfo/add`,
			name: "新增合同主体信息",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		update: {
			url: `${config.API_URL}/api/ly/contract/SubjectInfo/update`,
			name: "更新合同主体信息",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		delete: {
			url: `${config.API_URL}/api/ly/contract/SubjectInfo/delete/`,
			name: "删除合同主体信息",
			get: async function (data = {}) {
				return await http.get(`${this.url}/${data}`);
			},
		},
	},
	signedOrg: {
		page: {
			url: `${config.API_URL}/api/ly/signedOrg/page`,
			name: "签约公司列表",
			get: async function (data = {}, config = {}) {
				return await http.get(this.url, data, config);
			},
		},
		add: {
			url: `${config.API_URL}/api/ly/signedOrg/add`,
			name: "新增公司信息",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		update: {
			url: `${config.API_URL}/api/ly/signedOrg/update`,
			name: "修改公司信息",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		delete: {
			url: `${config.API_URL}/api/ly/signedOrg/delete`,
			name: "删除公司信息",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		export: {
			url: `${config.API_URL}/api/ly/signedOrg/export`,
			name: "导出签约公司列表",
			get: async function (data = {}, config = {}) {
				return await http.get(this.url, data, config);
			},
		},
	},
	contract: {
		list: {
			url: `${config.API_URL}/api/ly/contract/page`,
			name: "订单合同分页",
			get: async function (data = {}, config = {}) {
				return await http.get(this.url, data, config);
			},
		},
		add: {
			url: `${config.API_URL}/api/ly/contract/addContract`,
			name: "新增合同",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		edit: {
			url: `${config.API_URL}/api/ly/contract/editContract`,
			name: "编辑合同",
			post: async function (data = {}, config = {}) {
				return await http.post(this.url, data, config);
			},
		},
		send: {
			url: `${config.API_URL}/api/ly/contract/sendContract`,
			name: "发起合同",
			get: async function (data = {}, config = {}) {
				return await http.get(this.url, data, config);
			},
		},
		evocation: {
			url: `${config.API_URL}/api/ly/contract/revocationContract`,
			name: "撤回合同",
			get: async function (id, revocationMemo) {
				return await http.get(
					`${this.url}?id=${id}&revocationMemo=${revocationMemo}`,
				);
			},
		},
		stop: {
			url: `${config.API_URL}/api/ly/contract/stopContract`,
			name: "终止合同",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		log: {
			url: `${config.API_URL}/api/ly/contract/log`,
			name: "日志",
			get: async function (data = {}, config = {}) {
				return await http.get(this.url, data, config);
			},
		},
		sendVerify: {
			url: `${config.API_URL}/api/ly/contract/sendVerify`,
			name: "发起合同审核",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		detail: {
			url: `${config.API_URL}/api/ly/contract/detail`,
			name: "合同详情",
			get: async function (id) {
				return await http.get(`${this.url}?id=${id}`);
			},
		},
		guakaoOrgPage: {
			url: `${config.API_URL}/api/ly/contract/guakaoOrgPage`,
			name: "获取挂靠企业列表",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		info: {
			url: `/ly/app/contract/appUserDetail`,
			name: "获取表格信息",
			async get(data = {}) {
				return await http.get(this.url, data);
			},
		},
		infoID: {
			url: `/api/ly/contract/orgList`,
			name: "获取用户id",
			async get(data = {}) {
				return await http.get(this.url, data);
			},
		},
		preview: {
			url: `/api/ly/contract/templatePreview`,
			name: "预览合同",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		guakaoOrgDetail: {
			url: `/api/ly/contract/guakaoOrgDetail`,
			name: "获取挂靠详情",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		userInfo: {
			url: `/api/ly/contract/userInfo`,
			name: "获取签约用户信息",
			get: async function (data = {}) {
				return await http.get(this.url, data);
			},
		},
		download: {
			url: `/api/ly/contract/downloadUrl`,
			name: "下载合同",
			get: async function (id) {
				return await http.get(`${this.url}/${id}`);
			},
		},
	},
};
